import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Transaction } from '../data/models';

@Component({
    selector: 'app-transaction-history-sidebar-item[transaction]',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
    :host {
      display: block;
    }

    .purchase-list {
      height: 64px;
      overflow: hidden;
    }

    .fade-effect {
      mask-image: linear-gradient(180deg, #000 0%, transparent);
    }

    .item-count {
      display: inline-block;
      width: 35px;
      text-align: end;
    }
  `],
    template: `
    <div class="d-flex flex-row justify-content-between">
      <div>
        <span class="flex-column fw-bolder fs-6">#{{ transaction?.transactionNumber }}</span>
        <ul class="list-unstyled fade-effect purchase-list">
          <li class="transaction-list-item-preview-item lh-sm" *ngFor="let product of transaction?.items">
            <span class="item-count pe-2 small">{{ product.quantity }}x</span>
            <span class="small">{{ product.title }}</span>
          </li>
        </ul>
      </div>
      <div class="d-flex flex-column">
        <span class="flex-column font-size text-muted small">{{ transaction | formatDate }}</span>
        <div class="d-flex flex-row justify-content-end">
          <span class="flex-column font-size text-muted small">{{ transaction | formatTime }} Uhr</span>
        </div>
      </div>
    </div>
  `,
    standalone: false
})
export class HistorySidebarItemComponent {
  @Input() transaction!: Transaction | null;
}
